<template>
  <div class="custom-options shadow-sm">
    <div
      v-if="loading"
      class="text-center mt-3"
    >
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </div>
    <div v-else>
      <div class="text-success">
        <GjIcon
          :name="iconName"
          size="24"
        />
      </div>

      <div class="mt-1 text-main">
        <span class="text-xl">{{ totalTitle }}</span>: <span class="text-semi-bold">{{ value }}</span>
      </div>

      <div class="custom-margin text-secondary">
        <p>{{ description }}</p>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'HeaderItem',
  components: {

  },
  props: {
    totalTitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";

.custom-options {
  width: 301px;
  height: 142px;
  border-radius: 5px;
  padding: 16px;
  background-color: $white;
}

.custom-margin{
  margin-top: 5px;
}

.text-semi-bold{
  font-size: 19px;
  font-weight: 500;
}
</style>
